/* @ngInject */
function DocumentsSectionController ($scope, $location, $rootScope, $q, TasksService, UdsModalService) {
  const getAttachInsideTheModuleModalController = () => $q.when(import('../../../repository/directives/attach-inside-the-module-modal/attach-inside-the-module-modal.controller'))
  const getChooseDocTemplateDialogController = () => $q.when(import('../../../repository/dialogs/choose-doc-template/choose-doc-template-dialog.controller'))

  const api = {
    getAttachInsideTheModuleModalController,
    getChooseDocTemplateDialogController,
    _getDocuments,
    _openChooseDocTemplateDialog,
    _attachAssetsToTask
  }
  this.getApi = () => api

  activate()

  function activate () {}

  const deregisterCollapsedWatch = $scope.$watch('flags.isCollapsed', (newValue) => {
    $scope.$emit('documents-section-collapsed-changed', newValue)
  })

  const deregisterTaskWatch = $scope.$watchCollection('task.id', () => {
    if ($scope.task) {
      api._getDocuments()
    }
  })

  const deregisterWorkflowReloadDocuments = $rootScope.$on('workflow.reloadDocuments', () => {
    api._getDocuments()
  })

  $scope.$on('$destroy', () => {
    deregisterWorkflowReloadDocuments()
    deregisterCollapsedWatch()
    deregisterTaskWatch()
  })

  $scope.openAttachAssetsDialog = function (isPrivate) {
    api.getAttachInsideTheModuleModalController().then(({ AttachInsideTheModuleModalController }) => {
      const attachInsideTheModuleModal = UdsModalService.createModal({
        controller: AttachInsideTheModuleModalController,
        modalName: 'attachInsideTheModuleModal',
        data: {
          selectedTab: 'recents',
          allowedAssetExtensionsSelection: ['deskfy'],
          showOnlyExtension: 'deskfy'
        },
        onClose: assetsToAttach => {
          if (!assetsToAttach?.length) {
            return
          }

          api._attachAssetsToTask(assetsToAttach)
        }
      })

      attachInsideTheModuleModal.open()
    })
  }

  function _attachAssetsToTask (assetsToAttach) {
    const assetsIds = assetsToAttach.map((a) => a.id)
    TasksService.attachDocumentsToTask($scope.task.id, assetsIds).then(() => {
      api._getDocuments()
    })
  }

  function _getDocuments () {
    TasksService.getTaskDocuments($scope.task.id).then((documents) => {
      $scope.documents = documents
    })
  }

  $scope.openChooseDocTemplateDialog = () => {
    api._openChooseDocTemplateDialog()
  }

  function _openChooseDocTemplateDialog () {
    api.getChooseDocTemplateDialogController().then(({ ChooseDocTemplateDialogController }) => {
      const modal = UdsModalService.createModal({
        controller: ChooseDocTemplateDialogController,
        modalName: 'chooseDocTemplateDialog',
        data: {
          taskId: $scope.task.id,
          location: 'requests'
        }
      })
      modal.open()
    })
  }
}

export { DocumentsSectionController }
